import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Ajustar foto de perfil", -1)
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "flex items-center gap-3 px-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500 text-center" }, " Arraste para posicionar e use o zoom para ajustar a foto. ", -1)
const _hoisted_5 = { class: "flex items-center justify-between w-full mt-2" }

import { onBeforeUnmount, ref, watch } from 'vue'
import { useToast } from 'vue-toastification'
import { mdiMagnifyMinusOutline, mdiMagnifyPlusOutline } from '@mdi/js'
import { Cropper, CircleStencil } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

const EXPORT_ERROR_MESSAGE = 'Não foi possível processar a imagem. Tente novamente.'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    modalActive: { type: Boolean },
    file: {},
    outputSize: { default: 512 }
  },
  emits: ["close", "cropped"],
  setup(__props: any, { emit }) {

const props = __props;





const toast = useToast()

const cropperRef = ref<InstanceType<typeof Cropper> | null>(null)
const imageSrc = ref<string | null>(null)
const isExporting = ref(false)
const zoomLevel = ref(1)

const revokeCurrentUrl = () => {
  if (imageSrc.value) {
    URL.revokeObjectURL(imageSrc.value)
    imageSrc.value = null
  }
}

watch(
  () => props.file,
  (file) => {
    revokeCurrentUrl()
    zoomLevel.value = 1
    if (file) imageSrc.value = URL.createObjectURL(file)
  },
  { immediate: true }
)

onBeforeUnmount(revokeCurrentUrl)

const onZoomSliderChange = (value: number) => {
  // zoom() da lib e relativo: com bind one-way no slider, zoomLevel ainda
  // guarda o valor anterior neste momento
  if (zoomLevel.value > 0) {
    cropperRef.value?.zoom(value / zoomLevel.value)
  }
  zoomLevel.value = value
}

const handleClose = () => {
  // Fechar durante o export dispararia o upload de um modal ja fechado
  if (isExporting.value) return
  emit('close')
}

const canvasToJpegBlob = (canvas: HTMLCanvasElement): Promise<Blob | null> =>
  new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.92))

const handleSave = async () => {
  // O canvas ja sai limitado a outputSize e com fundo branco via prop :canvas
  const canvas = cropperRef.value?.getResult().canvas
  if (!canvas) {
    toast.error(EXPORT_ERROR_MESSAGE)
    return
  }

  isExporting.value = true
  try {
    const blob = await canvasToJpegBlob(canvas)
    if (!blob) {
      toast.error(EXPORT_ERROR_MESSAGE)
      return
    }
    emit('cropped', new File([blob], 'avatar.jpg', { type: 'image/jpeg' }))
  } finally {
    isExporting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modalActive,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[500px]",
    onClose: handleClose
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(OutlinedButton, {
          "data-testid": "avatar-crop-cancel-button",
          text: "Cancelar",
          width: "120px",
          class: "!border-primary30 !text-primary30 !font-bold",
          onClick: handleClose
        }),
        _createVNode(FilledButton, {
          "data-testid": "avatar-crop-save-button",
          text: "Salvar",
          width: "120px",
          loading: isExporting.value,
          class: "!bg-primary !text-white !font-bold hover:!bg-primary40",
          onClick: handleSave
        }, null, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (imageSrc.value)
          ? (_openBlock(), _createBlock(_unref(Cropper), {
              key: 0,
              ref_key: "cropperRef",
              ref: cropperRef,
              class: "h-72 w-full rounded-lg bg-gray-900",
              src: imageSrc.value,
              "stencil-component": _unref(CircleStencil),
              "stencil-props": { aspectRatio: 1 },
              canvas: { maxWidth: _ctx.outputSize, maxHeight: _ctx.outputSize, fillColor: '#ffffff' },
              "image-restriction": "stencil",
              "data-testid": "avatar-crop-cropper"
            }, null, 8, ["src", "stencil-component", "canvas"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_icon, {
            size: "18",
            class: "text-gray-500"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(mdiMagnifyMinusOutline)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_slider, {
            "model-value": zoomLevel.value,
            min: 1,
            max: 3,
            step: 0.01,
            "hide-details": "",
            color: "primary",
            "track-color": "grey-lighten-2",
            "data-testid": "avatar-crop-zoom-slider",
            "onUpdate:modelValue": onZoomSliderChange
          }, null, 8, ["model-value"]),
          _createVNode(_component_v_icon, {
            size: "18",
            class: "text-gray-500"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(mdiMagnifyPlusOutline)), 1)
            ]),
            _: 1
          })
        ]),
        _hoisted_4
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})